export default __webpack_public_path__ + "static/media/btc_sm.c0695a27.svg";